"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerDropdownOption = exports.BmDropdownOption = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@blue/element");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<slot></slot>\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host {\n\t\tdisplay: table-row;\n\t\tbackground-color: white;\n\t}\n\n\t::slotted(*) {\n\t\tdisplay: table-cell;\n\t\tfont-size: 14px;\n\t\tline-height: 30px;\n\t\tcolor: #37383d;\n\t\tpadding: 0 12px;\n\t\tvertical-align: middle;\n\t\theight: 36px;\n\t}\n\n\t:host([slot='headers']) ::slotted(*) {\n\t\tbackground-color: #f4f5f7;\n\t\tborder-bottom: 1px solid #d5d4d9;\n\t\tfont-weight: bold;\n\t\theight: 44px;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var style = (0, _element.css)(_templateObject());

var BmDropdownOption = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(BmDropdownOption, _BlueElement);

  var _super = (0, _createSuper2.default)(BmDropdownOption);

  function BmDropdownOption() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, BmDropdownOption);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    _this.value = void 0;
    _this.selectedDisplayValue = '';
    _this.disabled = void 0;
    _this.processed = false;
    _this._selected = false;
    return _this;
  }

  (0, _createClass2.default)(BmDropdownOption, [{
    key: "render",
    value: function render() {
      return this.html(_templateObject2());
    }
  }, {
    key: "selected",
    get: function get() {
      return this._selected;
    },
    set: function set(selected) {
      var wasSelected = this._selected;
      this._selected = this.canSelect && selected;

      if (this._selected && !wasSelected) {
        this.dispatchEvent(new CustomEvent('selected', {
          detail: this
        }));
      }
    }
  }, {
    key: "isHeader",
    get: function get() {
      return this.slot === 'headers';
    }
  }, {
    key: "canSelect",
    get: function get() {
      return !this.disabled && !this.isHeader;
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-dropdown-option';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        value: {
          type: Object
        },
        selectedDisplayValue: {
          type: String,
          attribute: 'selected-display-value'
        },
        disabled: {
          type: Boolean
        },
        selected: {
          type: Boolean,
          attribute: true,
          reflect: true
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return style;
    }
  }]);
  return BmDropdownOption;
}(_element.BlueElement);

exports.BmDropdownOption = BmDropdownOption;

var registerDropdownOption = function registerDropdownOption() {
  return (0, _element.register)(BmDropdownOption);
};

exports.registerDropdownOption = registerDropdownOption;
